<template>
  <div class="flex">
    <!-- 中间部分 -->
    <div class="middle">
      <!-- 企业信息 -->
      <div class="bg">
        <div class="company">
          <div class="flex-align-center companyImg">
            <img src="../assets/imgs/home/company.png" alt />
            <span class="companyName">{{ info.enterpriseName }}</span>
            <img src="../assets/imgs/home/certified.png" alt class="certified" v-if="enterpriseInfo.dataType == 2" />
            <!-- 企业是否认证 -->
            <img src="../assets/imgs/home/qi.png" alt class="type" v-if="info.dataType == 2 && (info.state == 1 || info.state == 4)" />
            <img src="../assets/imgs/home/noAut.png" class="type" alt="" v-if="info.state == -2" />
            <!-- 是否是管理员 -->
            <img src="../assets/imgs/home/guan.png" alt class="type" v-if="info.isAdmin == 1" />
            <!-- 矿种是否认证 -->
            <img src="../assets/imgs/home/kuang.png" alt class="type" v-if="info.dataType == 2" />
            <img src="../assets/imgs/home/noKuan.png" alt class="type" v-if="info.dataType == 1" />
          </div>
          <div class="companyLine">
            <span class="msgTitle">企业代码：</span>
            <span class="msgContent">{{ info.enterpriseCode }}</span>
          </div>
          <div class="companyLine">
            <span class="msgTitle">手机号码：</span>
            <span class="msgContent">{{ info.phone }}</span>
          </div>
          <div class="companyLine">
            <span class="msgTitle">用户名称：</span>
            <span class="msgContent">{{ info.userName }}</span>
            <img src="../assets/imgs/home/admin.png" alt class="admin" v-if="info.isAdmin == 1" />
          </div>
          <div class="companyLine">
            <span class="msgTitle">最近登录：</span>
            <span class="msgContent">{{info.thisLoginTime}}</span>
          </div>
        </div>
        <!-- 未认证 -->
        <div class="account" v-if="info.dataType == 1 && info.state == -2">
          <div class="accountBox flex">
            <div class="noCertified">
              <p class="title">当前用户还未通过企业认证</p>
              <div class="flex-align-center stepBox">
                <div class="step flex-align-center">
                  <p class="num">1</p>
                  <span>提交资料</span>
                </div>
                <div class="line"></div>
                <div class="step flex-align-center">
                  <p class="num">2</p>
                  <span>资质审核</span>
                </div>
                <div class="line"></div>
                <div class="step flex-align-center">
                  <p class="num">3</p>
                  <span>认证成功</span>
                </div>
              </div>
              <div class="certifiedBut">
                <router-link :to="{ path: '/authentication' }">认证企业资料</router-link>
              </div>
              <img src="../assets/imgs/home/noCertified.png" alt class="noCertifiedImg" />
            </div>
          </div>
        </div>
        <!-- 认证资料已提交 认证审核中 -->
        <div class="account" v-if="info.state == -1 && info.dataType == 1">
          <div class="accountBox flex">
            <div class="sbumitBox">
              <div class="submitTit">
                <img src="../assets/imgs/home/submit.png" alt="" />
                <span>认证资料已提交</span>
              </div>
              <div class="submitContent">
                <div class="contentTit">请您于5个工作日内携带以下相关资料及物品，前往所属市县交易中心现场办理：</div>
                <div>1:企业营业执照、法人身份证、经办人身份证、经办人委托书、销售合同、企业公章、乡镇政府证明原件及复印件（复印件需加盖公章）；</div>
                <div>2:企业公章；</div>
                <div>3:支撑版本4.0以上安卓系统手机一部。</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 待审核 -->
        <div class="account" v-if="info.state == 0 && info.dataType == 1">
          <div class="accountBox flex">
            <div class="attestationBox">
              <div class="attestationMsg">
                <img src="../assets/imgs/home/check.png" alt="" />
                <div class="txt">
                  <div>企业资料认证审核中，</div>
                  <div>请耐心等待…</div>
                </div>
                <img src="../assets/imgs/home/attestation.png" alt="" class="attestationImg" />
              </div>
            </div>
          </div>
        </div>
        <!-- 变更审核中 -->
        <div class="account" v-if="info.dataType == 2 && info.state == 0">
          <div class="accountBox flex">
            <div class="attestationBox">
              <div class="attestationMsg">
                <img src="../assets/imgs/home/check.png" alt="" />
                <div class="txt">
                  <div>企业资料变更认证审核中，</div>
                  <div>请耐心等待…</div>
                </div>
                <img src="../assets/imgs/home/attestation.png" alt="" class="attestationImg" />
              </div>
            </div>
          </div>
        </div>
        <!-- 企业未开户 -->
        <div class="account" v-if="info.dataType == 2 && (info.state == 1 || info.state == 4) && info.accountState == 1">
          <div class="accountBox flex">
            <div class="flex">
              <div class="left">
                <div class="flex-align-center">
                  <img src="../assets/imgs/home/count.png" alt />
                  <span>企业专用账户</span>
                </div>
                <!-- <div class="downAccount">下载开户凭证</div> -->
              </div>
              <div class="right noPayBox">
                <div class="noPayTxt">当前用户还未开启在线充值</div>
                <div class="payBut" @click="openLine = true">开启在线充值</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已提交开户申请 -->
        <div class="account" v-if="info.dataType == 2 && (info.state == 1 || info.state == 4) && info.accountState == 2">
          <div class="accountBox flex examine">
            <div class="flex">
              <div class="left">
                <div class="flex-align-center">
                  <img src="../assets/imgs/home/count.png" alt />
                  <span>企业专用账户</span>
                </div>
              </div>
              <div class="right">
                <div class="examineBox">
                  <img src="../assets/imgs/home/check.png" alt="" />
                  <div class="txt">账户申请受理中（约1-7个工作日）请耐心等待...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已开户 -->
        <div class="account" v-if="info.dataType == 2 && (info.state == 1 || info.state == 4) && info.accountState == 3">
          <div class="accountBox flex">
            <div class="left">
              <div class="flex-align-center">
                <img src="../assets/imgs/home/count.png" alt />
                <span>企业专用账户</span>
              </div>
              <div class="downAccount" @click="downAccount">下载开户凭证</div>
            </div>
            <div class="right flexccc">
              <div>
                <div>
                  <div class="flex-between-center">
                    <p class="title">代征账户名</p>
                  </div>
                  <p class="con">{{ info.hostBankAccountName }}</p>
                </div>
                <div class="line">
                  <p class="title">企业结算账户</p>
                  <p class="con">{{ info.vaAccount }}</p>
                </div>
                <div class="">
                  <p class="title">开户行</p>
                  <div class="flex-between-center">
                    <p class="con">{{ info.hostBankName }}</p>
                    <!-- <p class="copy flexr0c">
                      <span>复制账户</span>
                      <img src="../assets/imgs/home/copy.png" alt />
                    </p> -->
                  </div>
                </div>
              </div>
              <div class="problem" v-show="problemShow">
                <div class="problemBox">
                  <p class="title">注意事项：</p>
                  <p>1.您可通过网银或手机银行向该账户转账，即可为矿云通系统在线充值，到账时间大概3-6分钟，请及时在手机端查询资金明细；</p>
                  <p>2.建议使用手机银行进行转账，其他方式可能存在转账手续费，根据银行不同费率各有差异，请自行选择；</p>
                  <p>3.请妥善保管该账户信息。</p>
                </div>
              </div>
            </div>
            <img src="../assets/imgs/home/problem.png" alt @mouseover="problemShow = true" @mouseleave="problemShow = false" class="imgMsg" />
          </div>
        </div>
        <!-- 货款账户 -->
        <div class="account" v-show="isShowPayInfo">
          <div class="accountBox flex">
            <div class="left">
              <div class="flex-align-center">
                <img src="../assets/imgs/home/count.png" alt />
                <span>企业货款账户</span>
              </div>
            </div>
            <div class="right flexccc">
              <div>
                <div>
                  <div class="flex-between-center">
                    <p class="title">账户名称</p>
                  </div>
                  <p class="con">{{ paymentInfo.accountName }}</p>
                </div>
                <div class="line">
                  <p class="title">账户号码</p>
                  <p class="con">{{ paymentInfo.accountNo }}</p>
                </div>
              </div>
            </div>
            <img src="../assets/imgs/home/problem.png" alt @mouseover="problemShow = true" @mouseleave="problemShow = false" class="imgMsg" />
          </div>
        </div>
      </div>
      <!-- 过站信息 -->
      <div class="bg bg1 margin-top20" v-if="stationCard">
        <div class="titleLine flex-between-center">
          <p class="left">过站信息</p>
          <div class="right" @click="stationSearch">
            <span>过站信息查询</span>
            <img src="../assets/imgs/home/more.png" alt />
          </div>
        </div>
        <div class="flex-around-center numberBox">
          <div class="train item">
            <p>过站/调运车次</p>
            <h1>{{ stationInfo.COUNT }}</h1>
            <!-- <span>暂无</span> -->
          </div>
          <div class="line"></div>
          <div class="weight item">
            <p>累计重量(吨)</p>
            <h1>{{ stationInfo.WEIGHT }}</h1>
            <!-- <span>暂无</span> -->
          </div>
          <div class="line"></div>
          <div class="total item">
            <p>累计税费(元)</p>
            <h1>{{ stationInfo.MONEY }}</h1>
            <!-- <span>暂无</span> -->
          </div>
        </div>
      </div>
      <!-- 资金信息 -->
      <div class="bg margin20" v-if="false">
        <div class="titleLine flex-between-center">
          <p class="left">资金信息</p>
          <div class="right">
            <span>资金管理查询</span>
            <img src="../assets/imgs/home/more.png" alt />
          </div>
        </div>
        <div class="flex-around-center numberBox">
          <div class="all">
            <p>企业总资产（元）</p>
            <h1>20500.00</h1>
          </div>
          <div class="line"></div>
          <div class="noOpen">
            <p>自由资金(元)</p>
            <span>暂未启用</span>
          </div>
          <div class="line"></div>
          <div class="special">
            <p>矿云通专款(元)</p>
            <h1>20500.00</h1>
          </div>
        </div>
      </div>
      <!-- 平台消息 -->
      <div class="bg margin-top20">
        <div class="titleLine flex-between-center">
          <p class="left">平台消息</p>
          <div class="right" @click="announce">
            <span>查看更多</span>
            <img src="../assets/imgs/home/more.png" alt />
          </div>
        </div>
        <ul>
          <li class="flex-between-center infoLine" v-for="(item, index) in info.noticeList" :key="index">
            <div class="flex-align-center text">
              <span>{{ item.title }}</span>
              <img v-if="item.month == month" src="../assets/imgs/home/new.png" alt />
            </div>
            <div class="time">{{ item.addTime }}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 在线充值 -->
    <div class="recharge bg" v-if="recharge">
      <div class="titleLine flex-between-center">
        <p class="left">在线充值</p>
        <div class="right" @click="help">
          <span>常见问题</span>
          <img src="../assets/imgs/home/more.png" alt />
        </div>
      </div>
      <!-- 额度 -->
      <!-- <div class="rechargeBox">
        <p class="title">您目前可充值的额度约为（元）</p>
        <h1 class="total">20500.00</h1>
      </div> -->
      <!-- 网银转账 -->
      <div class="online item">
        <div class="payTitle">网银转账</div>
        <div class="payContent">您可通过网银或手机银行向企业专用账户转账，即可为矿云通系统在线充值，到账时间大概3-6分钟，请及时在手机端查询资金明细。</div>
        <div class="demo" @click="demoMask = true">
          <span>新手操作演示</span>
          <img src="../assets/imgs/home/demo.png" alt />
        </div>
        <div class="bottom">
          <img src="../assets/imgs/home/online.png" alt />
        </div>
      </div>
      <!-- 银联 -->
      <div class="card item">
        <div class="payTitle">银联支付</div>
        <div class="noOpen">暂未开通，敬请期待！</div>
        <div class="bottom">
          <img src="../assets/imgs/home/card.png" alt />
        </div>
      </div>
      <!-- 微信 -->
      <div class="wx item">
        <div class="payTitle">快捷支付</div>
        <div class="noOpen">暂未开通，敬请期待！</div>
        <div class="bottom">
          <img src="../assets/imgs/home/wx.png" alt />
        </div>
      </div>
    </div>
    <!-- 矿产调运 -->
    <div class="mineral bg" v-else>
      <div class="titleLine flex-between-center">
        <p class="left">矿产调运</p>
        <div class="right">
          <span>查看更多</span>
          <img src="../assets/imgs/home/more.png" alt />
        </div>
      </div>
      <!-- 预申报 -->
      <div class="box">
        <div class="title">
          <span>预申报调运</span>
          <span>非预申报调运</span>
        </div>
        <div class="contentImg">
          <img src="../assets/imgs/home/report.png" alt />
        </div>
        <div class="bottom">
          <div class="but">新增预申报</div>
          <!-- 非预申报 -->
          <div class="but">发放调运单</div>
        </div>
      </div>
    </div>
    <!--开户弹框  -->
    <div class="mask" v-show="openLine">
      <div class="window1">
        <div class="top flexrcc">
          <div class="title">开户确认</div>
          <img @click="closeModal" src="../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexc0c">
          <div class="txt1">您当前的纳税名额</div>
          <div class="txt2">{{ info.enterpriseName }}</div>
          <div>
            <div class="txt3">请仔细核对是否正确，该信息有误将导致</div>
            <div class="txt4">相关税票无法开具</div>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="window = 4">名称不符</div>
          <div class="save" @click="window = 2">名称相符</div>
        </div>
      </div>
      <div class="window2" v-if="window == 2">
        <div class="top flexrcc">
          <div class="title">再次确认</div>
          <img @click="closeModal" src="../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexc0c">
          <div class="txt1">请再次核对纳税名称</div>
          <div class="txt2">{{ info.enterpriseName }}</div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="window = 4">名称不符</div>
          <div class="save" @click="window = 3">名称相符,继续开启</div>
        </div>
      </div>
      <div class="window3" v-if="window == 3">
        <div class="top flexrcc">
          <div class="title">中资云用户使用协议</div>
          <img @click="closeModal" src="../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <protocol></protocol>
        </div>
        <div class="bottom flexrcc">
          <div class="save" @click="openCharge">同意并开启</div>
        </div>
      </div>
      <div class="window4" v-if="window == 4">
        <div class="top flexrcc">
          <div class="title">名称变更</div>
          <img @click="closeModal" src="../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexc0c">
          <div class="txt">如纳税名称与现实情况不符，请联系所属市县管理机构进行变更后，再激活开户。</div>
          <div class="card flexc0c">
            <div class="top-txt">{{ orgName }}</div>
            <div class="split-line"></div>
            <div class="bottom-content">
              <div class="flexr0c">
                <img src="../assets/imgs/home/phone.png" alt="" />
                <div class="label">联系电话</div>
                <div class="value">{{ orgExt && orgExt.mobileNo }}</div>
              </div>
              <div class="flexr0c">
                <img src="../assets/imgs/home/location.png" alt="" />
                <div class="label">办公地址</div>
                <div class="value">{{ orgExt && orgExt.workAddr }}</div>
              </div>
              <div class="flexr0c">
                <img src="../assets/imgs/home/time.png" alt="" />
                <div class="label">工作时间</div>
                <div class="value">{{ orgExt && orgExt.workTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="save" @click="closeModal">关闭</div>
        </div>
      </div>
    </div>
    <!-- 新手操作 -->
    <div class="mask" v-show="demoMask">
      <div class="demoBox">
        <Icon type="md-close" class="close" size="26" @click="demoMask = false" />
        <div class="demoMask" v-show="indexShow">
          <img src="../assets/imgs/home/xinshoucaozuo.png" alt="" />
          <div class="topArrow" @mouseover="moveIn('pc')" @mouseleave="pcShow = false" @click="indexShow = false"></div>
          <div class="upArrow" @mouseover="moveIn('phone')" @mouseleave="phoneShow = false" @click="indexShow = false"></div>
          <img src="../assets/imgs/home/arrow.png" alt="" class="topTip" v-show="pcShow" />
          <img src="../assets/imgs/home/arrow.png" alt="" class="upTip" v-show="phoneShow" />
        </div>
        <div class="demoContent">
          <!-- 网上银行转账 -->
          <div class="pcBox" v-show="demoType == 'pc'">
            <img src="../assets/imgs/home/P1.png" alt="" v-show="step == 1" @click="step = 2" />
            <img src="../assets/imgs/home/P2.png" alt="" v-show="step == 2" @click="step = 3" />
            <img src="../assets/imgs/home/P3.jpg" alt="" v-show="step == 3" @click="step = 4" />
            <img src="../assets/imgs/home/P4.jpg" alt="" v-show="step == 4" @click="step = 5" />
            <img src="../assets/imgs/home/P5.png" alt="" v-show="step == 5" @click="close" />
          </div>
          <!-- 手机银行转换 -->
          <div class="phoneBox" v-show="demoType == 'phone'">
            <img src="../assets/imgs/home/P6.png" alt="" v-show="step == 1" @click="step = 2" />
            <img src="../assets/imgs/home/P7.png" alt="" v-show="step == 2" @click="step = 3" />
            <img src="../assets/imgs/home/P8.png" alt="" v-show="step == 3" @click="step = 4" />
            <img src="../assets/imgs/home/P9.png" alt="" v-show="step == 4" @click="step = 5" />
            <img src="../assets/imgs/home/P10.png" alt="" v-show="step == 5" @click="close" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import protocol from "@/components/protocol";
import { mapState, mapMutations } from "vuex";
export default {
  name: "shouye",
  data () {
    return {
      pcShow: false,
      phoneShow: false,
      indexShow: true,
      demoMask: false,
      openLine: false,
      problemShow: false,
      recharge: true,
      account: true,
      window: 0,
      orgExt: {},
      orgName: "",
      helpId: "", //在线充值的fid
      stationId: "", //过站充值的fid
      info: {
        thisLoginTime: {},
        passStationMap: {},
      },
      enterpriseInfo: {},
      session: {},
      demoType: "pc",
      step: 1,
      phone: 1,
      month: 0,
      stationInfo: {}, // 过站信息
      isShowPayInfo: false, // 是否显示
      paymentInfo: {}, // 货款账户信息
    };
  },
  created () {
    this.session = JSON.parse(localStorage["session"]);
    this.month = new Date().getMonth() + 1;
  },
  mounted () {
    this.getShouyeInfo();
    this.getComInfo();
    this.getStationInfo();
    this.getPaymentInfo();
    this.openCharge = this.throttle(this.openOnlineCharge, 2000);
    if (localStorage.getItem("orgExt") != 'undefined') {
      this.orgExt = JSON.parse(localStorage.getItem("orgExt"));
    }
    this.orgName = localStorage.getItem("orgName");
    this.helpId = localStorage.getItem("help");
    this.stationId = localStorage.getItem("stationId");
  },
  methods: {
    ...mapMutations(["setContentType", "setMenuName", "showStation"]),
    downAccount () {
      this.$router.push("certificatePrint");
    },
    getPaymentInfo () {
      this.$http.post({
        sessionId: JSON.parse(localStorage["session"]).sessionId,
        enterpriseId: JSON.parse(localStorage["session"]).enterpriseId,
        modeCode: "cgNBijodq4qov0Z3tyN9PjgRNKlVyaui"
      }).then(res => {
        if (res.code == 1) {
          this.isShowPayInfo = true;
          this.paymentInfo = res.data;
        } else {
          this.isShowPayInfo = false;
        }
      });
    },
    //节流
    throttle (fn, wait) {
      var pre = Date.now();
      return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
          fn.apply(context, args);
          pre = Date.now();
        }
      };
    },
    closeModal () {
      this.openLine = false;
      this.window = 0;
      this.getShouyeInfo();
    },
    close () {
      this.step = 1;
      this.indexShow = true;
    },
    moveIn (type) {
      this.demoType = type;
      type == "pc" ? (this.pcShow = true) : (this.phoneShow = true);
    },
    // 获取过站信息
    getStationInfo () {
      this.$http.post({
        sessionId: JSON.parse(localStorage["session"]).sessionId,
        enterpriseId: JSON.parse(localStorage["session"]).enterpriseId,
        modeCode: "amp6HxUfNxsVvtWne5ZkBVYwId2kQvA6"
      }).then(res => {
        if (res.code == 1) {
          this.stationInfo = res.data.passStationMap;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    // 获取首页数据
    getShouyeInfo () {
      let session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: JSON.parse(localStorage["session"]).sessionId,
        userId: JSON.parse(localStorage["session"]).userId,
        enterpriseId: JSON.parse(localStorage["session"]).enterpriseId,
        type: "passStation",
        pageSize: 5,
        modeCode: "f5Ov1SBh0ZGcO01FV5ZbVsSgyfZqPvb7",
        userId: session.userId,
        enterpriseId: session.enterpriseId,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          res.data.noticeList.forEach((item) => {
            item.month = item.addTime.split("-")[1];
          });
          localStorage.setItem("phone", res.data.phone);
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    getComInfo () {
      let data = {
        sessionId: JSON.parse(localStorage["session"]).sessionId,
        modeCode: "YYpXas9qlSnJWer5Ru21Zm1bV77ZB6cl",
        userId: JSON.parse(localStorage["session"]).userId,
        enterpriseId: JSON.parse(localStorage["session"]).enterpriseId,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.enterpriseInfo = res.data.enterpriseInfo; //企业信息
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    openOnlineCharge () {
      let data = {
        sessionId: JSON.parse(localStorage["session"]).sessionId,
        modeCode: "AzRyT6BeU5kbrRnEpVirN31JXJY1A5bQ",
        userId: JSON.parse(localStorage["session"]).userId,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.openLine = false;
          this.window = 0;
          this.getShouyeInfo();
          this.$Message["success"]({
            background: true,
            content: res.msg,
          });
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    stationSearch () {
      this.setMenuName(this.stationId);
      this.setContentType(7);
    },
    help () {
      localStorage.setItem("name", "在线充值");
      localStorage.setItem("fid", this.helpId);
      this.setMenuName(this.helpId);
      this.setContentType(15);
    },
    announce () {
      this.setMenuName(localStorage.getItem("announcement"));
      this.setContentType(10);
    },
  },
  computed: {
    ...mapState(["loginInfo", "contentType", "stationCard"]),
  },
  components: {
    protocol,
  },
};
</script>

<style lang="less" scoped>
#home {
  header {
    background: #f7f9fd;
    .headerTop {
      height: 34px;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #616c84;
      letter-spacing: -0.43px;
      .rightItem {
        cursor: pointer;
      }

      .rightItem:first-child::after {
        content: "|";
        padding: 0 10px;
      }

      .user {
        color: #2c59c3;
      }
    }
  }
  nav {
    background: #2c59c3;
    color: #fff;
    height: 60px;
    line-height: 60px;

    .logo {
      img {
        vertical-align: middle;
      }
    }

    .infoBox {
      position: relative;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      span {
        width: 6px;
        height: 6px;
        display: block;
        border-radius: 50%;
        background: #ff3100;
        position: absolute;
        top: 22px;
        right: 22px;
      }

      .infoList {
        position: absolute;
        top: 40px;
        left: -75px;
        width: 160px;
        height: 88px;
        background: url("../assets/imgs/home/infoBg.png") no-repeat;
        box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
        z-index: 666;
        border-radius: 10px;
        color: #999999;

        li {
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
        }

        li:first-child {
          margin-top: 8px;
          border-bottom: 1px solid #ebedf3;
        }

        li:hover {
          color: #4a4a4a;
        }
      }
    }

    .infoBox::after {
      content: "|";
      padding: 0 10px;
    }

    .down {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      cursor: pointer;

      img {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }

  // 中间内容
  section {
    min-height: 800px;
    padding: 20px 0;
    aside {
      width: 200px;
      background: #ffffff;
      border: 1px solid #ebebeb;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      cursor: pointer;
      ul {
        li {
          list-style: none;
        }
        li.title {
          padding: 0 15px;
          height: 40px;
          line-height: 40px;
          background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
          border-radius: 10px 10px 0 0;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #616c84;
          letter-spacing: -0.57px;

          img {
            margin-right: 10px;
          }

          .arrow {
            text-align: right;
            vertical-align: middle;
          }
        }

        .itemContent {
          border-bottom: 1px solid rgba(235, 235, 235, 0.6);

          li.item {
            font-family: PingFangSC-Regular;
            font-size: 0px;
            color: #616c84;
            letter-spacing: -0.57px;
            padding: 0 40px;
            height: 0px;
            line-height: 0px;
          }
        }
      }
    }

    .middle {
      width: 560px;
      margin: 0 20px;
    }

    .bg {
      background: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 15px 20px 15px;
    }

    .bg1 {
      padding: 15px 20px 25px;
    }

    .margin-top20 {
      margin-top: 20px;
    }

    .company {
      .companyImg {
        margin-bottom: 10px;

        .type {
          margin-right: 5px;
        }
      }

      .companyName {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #4a4a4a;
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 15px;
      }

      .certified {
        margin: 0 5px;
      }

      .companyLine {
        margin: 5px 0;

        .msgTitle {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0;
        }

        .msgContent {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0;
        }

        .admin {
          margin: 0 5px;
          vertical-align: middle;
        }
      }
    }

    .noPayBox {
      // width:60%;
      margin: 0 60px;
      box-sizing: border-box;
      padding: 20px 0;

      .noPayTxt {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #abafb7;
        letter-spacing: 0;
      }

      .payBut {
        background-image: linear-gradient(180deg, #fa7864 0%, #f44334 100%);
        border: 1px solid #f44536;
        box-shadow: 0 3px 6px 0 rgba(244, 67, 52, 0.4);
        border-radius: 4px;
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.37px;
        margin: 20px auto;
        cursor: pointer;
      }
    }

    .account {
      border-top: 5px solid #2c59c3;
      border-radius: 5px;
      background: #f5f5f5 url("../assets/imgs/home/accountBg.png") no-repeat;
      background-position: 100%;
      width: 520px;
      height: 160px;
      margin: 10px auto;
      box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);

      .examine {
        .left {
          width: 200px !important;
        }
      }

      .accountBox {
        width: 90%;
        margin: 15px auto;
        height: 120px;
        position: relative;
        .attestationBox {
          width: 90%;
          position: relative;

          .attestationMsg {
            margin: 30px 50px;
            display: flex;
            align-items: center;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
            font-weight: 600;

            .txt {
              margin-left: 10px;
            }
          }

          .attestationImg {
            position: absolute;
            right: 0;
            top: 0;
          }
        }

        .sbumitBox {
          width: 95%;

          // text-align:center;
          img {
            vertical-align: middle;
            margin-right: 5px;
          }

          .submitTit {
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #70b231;
            letter-spacing: 0.26px;
          }

          .submitContent {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #4a4a4a;
            letter-spacing: 0.22px;

            .contentTit {
              margin: 10px 0;
              font-weight: 600;
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #4a4a4a;
              letter-spacing: 0.22px;
            }
          }
        }

        .left {
          width: 140px;
          border-right: 1px dashed #ebedf3;

          span {
            margin: 0 10px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #2c59c3;
            letter-spacing: 0.39px;
            font-weight: 600;
          }

          .downAccount {
            width: 117px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
            border: 1px solid #285ed3;
            border-radius: 4px;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0.3px;
            margin: 65px 0 0;
            cursor: pointer;
          }
        }

        .right {
          position: relative;
          padding-left: 20px;
          height: 120px;
          padding-right: 20px;

          .content {
            width: 280px;

            .txt {
              font-family: PingFangSC-Medium;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
              margin-left: 5px;
            }
          }

          .line {
            margin: 10px 0;
          }

          .title {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #8b93a7;
            letter-spacing: 0.3px;
          }

          .con {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #25265e;
            letter-spacing: 0.3px;
          }

          .copy {
            margin-left: 30px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #c2c2d2;
            letter-spacing: 0;

            img {
              vertical-align: middle;
              margin-left: 3px;
            }
          }

          .problem {
            position: absolute;
            top: -85px;
            left: 280px;
            background: url("../assets/imgs/home/problemBg.png") no-repeat;
            background-size: 100%;
            width: 487px;
            height: 216px;

            .problemBox {
              width: 80%;
              margin: 20px 0 0 58px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;

              .title {
                font-size: 12px;
                color: #8b93a7;
              }
            }
          }
        }

        .examineBox {
          width: 100%;
          margin: 35px 20px;
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 25px;
            margin-right: 10px;
          }

          .txt {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
          }
        }
      }
      .imgMsg {
        position: absolute;
        top: 5px;
        right: 25px;
      }
      .noCertified {
        color: #c3c3c3;
        position: relative;

        .title {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #abafb7;
          letter-spacing: 0;
          margin: 20px 0 10px 100px;
        }

        .stepBox {
          margin: 0 30px;

          .step {
            .num {
              width: 26px;
              height: 26px;
              line-height: 26px;
              border-radius: 50%;
              border: 1px solid #c3c3c3;
              color: #c3c3c3;
              text-align: center;
              margin: 0 5px;
            }
          }

          .line {
            width: 20px;
            height: 1px;
            margin: 0 10px;
            background: #c3c3c3;
          }
        }

        .certifiedBut {
          background-image: linear-gradient(180deg, #fa7864 0%, #f44334 100%);
          border: 1px solid #f44536;
          box-shadow: 0 3px 6px 0 rgba(244, 67, 52, 0.4);
          border-radius: 4px;
          width: 130px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          letter-spacing: 0.37px;
          margin: 10px 120px;
          cursor: pointer;

          & > a {
            color: #ffffff;
          }
        }

        .noCertifiedImg {
          position: absolute;
          right: -80px;
          top: 10px;
        }
      }
    }

    .titleLine {
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf3;

      .left {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.4px;
        font-weight: 600;
      }

      .right {
        cursor: pointer;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #2c59c3;
        letter-spacing: 0.35px;

        img {
          margin-left: 10px;
        }
      }
    }

    .numberBox {
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8b93a7;
      letter-spacing: 0.35px;
      margin: 20px 0 0;

      .line {
        width: 1px;
        height: 30px;
        margin-top: 55px;
        background: #ebedf3;
      }

      h1 {
        font-family: Impact;
        letter-spacing: 0.85px;
        font-size: 34px;
        margin: 15px 0 0;
      }

      .item {
        height: 87px;

        p {
          margin-bottom: 25px;
        }

        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
        }
      }

      .train {
        h1 {
          color: #7ed321;
        }
      }

      .weight {
        h1 {
          color: #4a90e2;
        }
      }

      .total {
        h1 {
          color: #f5a623;
        }
      }

      .all {
        h1 {
          color: #f87117;
        }
      }

      .noOpen {
        height: 87px;

        p {
          margin-bottom: 30px;
        }

        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
        }
      }

      .special {
        h1 {
          color: #2c59c3;
        }
      }
    }

    .infoLine {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4a4a4a;
      letter-spacing: 0.35px;
      margin: 10px 0;

      .text {
        width: 65%;

        span {
          white-space: nowrap;
          /*设置不换行*/
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .time {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #8b93a7;
        letter-spacing: 0.35px;
      }
    }

    //在线充值
    .recharge {
      width: 400px;
      height: 800px;

      .rechargeBox {
        margin: 20px 10px;

        .title {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0.35px;
        }

        .total {
          font-family: Impact;
          font-size: 42px;
          color: #f87117;
          letter-spacing: 1.05px;
          margin: 5px 0;
        }
      }

      .item {
        width: 360px;
        background: #ffffff;
        margin: auto;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        border-radius: 10px;

        .payTitle {
          border-radius: 10px 10px 0 0;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
        }

        .payContent {
          width: 81%;
          margin: 15px auto;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          letter-spacing: 0;
          line-height: 20px;
          text-indent: 2em;
        }

        .noOpen {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
          text-align: center;
          margin: 35px 0;
        }

        .bottom {
          text-align: center;
          margin-top: 20px;
          border-top: 1px solid #ebedf3;

          img {
            margin-top: 8px;
          }
        }
      }

      // 网银
      .online {
        height: 232px;
        margin: 20px 0;

        .payTitle {
          background-image: linear-gradient(180deg, #f8aaa2 0%, #f15949 100%);
        }

        .demo {
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #af2534;
          letter-spacing: 0;
          margin-top: 48px;
          cursor: pointer;

          img {
            vertical-align: middle;
            margin: 0 4px;
          }
        }
      }

      // 银联
      .card {
        height: 159px;
        margin: 20px auto;

        .payTitle {
          background-image: linear-gradient(180deg, #88caec 0%, #0b91d7 100%);
        }
      }

      // 快捷支付
      .wx {
        height: 159px;

        .payTitle {
          background-image: linear-gradient(180deg, #80d68e 0%, #00ac1c 100%);
        }
      }
    }

    // 矿产调运
    .mineral {
      width: 400px;
      height: 422px;

      .box {
        width: 360px;
        margin: 30px auto;
        background: #ffffff;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        border-radius: 10px;

        .title {
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.98) 0%,
            #2c59c3 100%
          );
          border-radius: 10px 10px 0 0;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.37px;
        }

        .contentImg {
          text-align: center;
          margin: 30px auto;
        }

        .bottom {
          border-top: 1px dashed #ebedf3;
          height: 60px;

          .but {
            background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
            border: 1px solid #4c9b25;
            border-radius: 4px;
            width: 117px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.35px;
            margin: 15px auto;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;

  .window1,
  .window2 {
    width: 480px;
    height: 282px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    .top {
      width: 100%;
      height: 46px;
      background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
      border-radius: 10px 10px 0 0;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
      }

      img {
        position: absolute;
        float: right;
        width: 16px;
        height: 16px;
        right: 15px;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      height: 186px;
      background: #fff;
      overflow: hidden;

      .txt1 {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
        margin-top: 25px;
      }

      .txt2 {
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #cf3510;
        letter-spacing: 0;
        margin: 20px 0;
      }

      .txt3,
      .txt4 {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0;
        text-align: center;
      }
    }

    .bottom {
      // transform: scaleY(-1);
      background: #f5f5f5;
      border-radius: 0 0 10px 10px;
      height: 50px;
      text-align: center;

      .cancel {
        width: 138px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.97) 0%,
          rgba(251, 251, 251, 0.98) 37%,
          #f5f5f5 100%
        );
        border: 1px solid #cacaca;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #e9e9e9 100%
          );
        }
      }

      .save {
        width: 138px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
        }
      }
    }
  }

  .window3 {
    width: 940px;
    height: 720px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    .top {
      width: 100%;
      height: 46px;
      background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
      border-radius: 10px 10px 0 0;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
      }

      img {
        position: absolute;
        float: right;
        width: 16px;
        height: 16px;
        right: 15px;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      padding: 35px;
      height: 560px;
      background: #fff;
      overflow: auto;
    }

    .bottom {
      width: 100%;
      height: 130px;
      background: #fff;
      border-radius: 0 0 10px 10px;
      text-align: center;

      .save {
        width: 368px;
        height: 48px;
        line-height: 48px;
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 8px;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
        }
      }
    }
  }

  .window4 {
    width: 480px;
    height: 390px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    .top {
      width: 100%;
      height: 46px;
      background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
      border-radius: 10px 10px 0 0;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
      }

      img {
        position: absolute;
        float: right;
        width: 16px;
        height: 16px;
        right: 15px;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      height: 294px;
      background: #fff;

      .txt {
        width: 364px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0;
        margin: 47px 0 31px 0;
      }

      .card {
        width: 408px;
        height: 140px;
        background: url("../assets/imgs/home/card-bg.png") no-repeat;

        .top-txt {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0;
          margin: 10px 0;
        }

        .split-line {
          height: 1px;
          width: 356px;
          border: 1px dashed #d9dfe9;
        }

        .bottom-content {
          width: 310px;
          margin-top: 15px;

          .label {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #9097a9;
            letter-spacing: 0;
            margin: 0 8px;
          }

          .value {
            font-family: HelveticaNeue;
            font-size: 14px;
            color: #252a37;
            letter-spacing: 0;
          }
        }
      }
    }

    .bottom {
      width: 100%;
      height: 50px;
      background: #f5f5f5;
      border-radius: 0 0 10px 10px;
      text-align: center;

      .save {
        width: 138px;
        height: 30px;
        line-height: 30px;
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
        }
      }
    }
  }
}

.demoBox {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -287px;
  margin-left: -336px;
  width: 672px;
  height: 594px;
  background: #fff;

  .close {
    z-index: 99999;
    margin: 4px;
  }

  .demoMask {
    position: absolute;
    width: 96%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.7);
    text-align: center;

    img {
      margin: 60px auto;
    }

    .topTip,
    .upTip {
      position: absolute;
      left: 45px;
      -webkit-animation: dou 0.8s infinite;
      -webkit-animation-fill-mode: both;
    }

    @-webkit-keyframes dou {
      0% {
        -webkit-transform: translate(0, 0px);
      }

      50% {
        -webkit-transform: translate(-6px, 0px);
      }

      100% {
        -webkit-transform: translate(-10px, 0px);
      }
    }

    .topTip {
      top: 170px;
    }

    .upTip {
      top: 330px;
    }

    .topArrow {
      width: 344px;
      height: 140px;
      position: absolute;
      margin: 0 auto;
      left: 0px;
      right: 0px;
      top: 162px;
      z-index: 222;
      cursor: pointer;
    }

    .upArrow {
      width: 344px;
      height: 140px;
      position: absolute;
      margin: 0 auto;
      left: 0px;
      right: 0px;
      top: 328px;
      z-index: 222;
      cursor: pointer;
    }
  }

  .close {
    float: right;
  }

  .demoContent {
    box-sizing: border-box;
    padding: 20px;
    text-align: center;

    .phoneBox {
      margin: 20px auto;
    }
  }
}
</style>
